<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>
<div *ngIf="!showSpinner">
  <app-menu></app-menu>
  <mat-card class="resumo-card">
    <mat-card-title>
      <h2>
       Resumo da equipe: {{ equipeNome }}
      </h2>
    </mat-card-title>

    <mat-card-content>
      <p><b>Desafio escolhido:</b></p>
      <p>{{ tituloDesafioEscolhido }}</p>
      <p>{{ descricaoDesafioEscolhido }}</p>

      <p><b>Membros:</b></p>
      <div *ngFor="let membro of membrosEquipe">
        <div class="row membro">
          <img class="profile-img" [src]="membro.photoURL">
          <p class="user">{{ membro.displayName || membro.uid }}</p>
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions align="end">

      <!-- chama os sair da equipe -->
      <button mat-flat-button
        [ngStyle]="{'margin': '8px', 'background-color': 'red', 'color': 'white'}"
        [routerLink]="['/hackathon/equipes']"
        (click)="sairDaEquipe()"
        routerLinkActive="active">
        Sair da equipe
      </button>

      <!-- chama os desafios -->
      <button
        mat-flat-button
        [ngStyle]="{'margin': '8px'}"
        routerLinkActive="active"
        *ngIf="helper.hackathonLiberarDesaios"
        (click)="escolherDesafio()">
        Desafios
      </button>

      <!-- chama as entregas -->
      <button
        mat-flat-button
        [ngStyle]="{'margin': '8px'}"
        routerLinkActive="active"
        *ngIf="helper.hackathonLiberarEntregas"
        (click)="fazerEntregas()">
        Entregas
      </button>

      <!-- chama os resultados -->
      <button
        mat-flat-button
        [ngStyle]="{'margin': '8px'}"
        [routerLink]="['/detalhes']"
        routerLinkActive="active"
        *ngIf="helper.hackathonLiberarResultado"
        (click)="helper.routeToDetalhes()">
        Resultado
      </button>

    </mat-card-actions>
  </mat-card>
</div>
